import React from "react";
import { Grid, Typography, Box } from "@mui/material/";
import { makeStyles } from "@mui/styles";
import { strings } from "../../../common/i18n";
import styles from "./styles";

type Props = {
    label: string,
    value: string,
    cls?: string
};

const useStyles = makeStyles(styles);

export default function GridColumn({ label, value, cls }: Props) {
    const classes = useStyles();

    return (
        <Grid
            item
            xs={6}
            className={classes.commonSpacing}
            key={label}
            sx={{ mb: 0.5 }}
        >
            <Box display="flex" alignItems="center" width="100%" gap={1}>
                {/* Label with less width */}
                <Typography
                    variant="body2"
                    title={strings(label)}
                    className={classes.columnLabel}
                    sx={{ flexShrink: 0, flexBasis: "25%", fontWeight: 500 }}
                >
                    {strings(label)}:
                </Typography>

                {/* Value takes more space */}
                <Typography
                    variant="body2"
                    className={`${classes.columnText} ${cls || ""}`}
                    sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        flexGrow: 1,
                        cursor: "default"
                    }}
                    title={value || "\u2014"}
                >
                    {value || "\u2014"}
                </Typography>
            </Box>
        </Grid>
    );
}
